import { render, staticRenderFns } from "./actionsFooter.vue?vue&type=template&id=9b6979aa"
import script from "./actionsFooter.vue?vue&type=script&lang=js"
export * from "./actionsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports